import {
  PERFORMANCE_DEFAULT_SORTING,
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT,
} from "../../../constants/shared/performanceFilter.constants";

export const individualGroupProfileConstants = {
  OR: " OR ",
  AND: " AND ",
  NAME: "name",
  STATE: "state",
  GROUP_DETAIL: "GROUP_DETAIL",
  STORES_BY_GROUP_ID: "STORES_BY_GROUP_ID",
  PAGINATED_GROUPS_DATA: "PAGINATED_GROUPS_DATA",
  GET_STORES_BY_GROUPS_IDS: "GET_STORES_BY_GROUPS_IDS",
};

export const INDIVIDUAL_GROUP_PROFILE_DEFAULT_SORTING =
  PERFORMANCE_DEFAULT_SORTING;

export const INDIVIDUAL_GROUP_PROFILE_SELECT_MAX_MENU_HEIGHT =
  PERFORMANCE_FILTER_SELECT_MAX_MENU_HEIGHT;

export const INDIVIDUAL_GROUP_PROFILE_LABELS = {
  GENERAL: "General",
  STORES: "Stores",
  GROUP_NAME: "Group Name:",
  GROUP_ID: "Group ID:",
  SEARCH_PLACEHOLDER: "Search",
};
